<template>
  <div class="vertical-layout h-100">
    <!-- Navbar -->
    <b-navbar
      :toggleable="false"
      variant="light"
      class="header-navbar navbar navbar-shadow align-items-center"
    >
      <slot
        name="navbar"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
      >
        <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
      </slot>
    </b-navbar>
    <!--/ Navbar -->

    <!-- Vertical Nav Menu -->
    <vertical-nav-menu
      :is-vertical-menu-active="isVerticalMenuActive"
      :toggle-vertical-menu-active="toggleVerticalMenuActive"
    >
      <template #header="slotProps">
        <slot
          name="vertical-menu-header"
          v-bind="slotProps"
        />
      </template>
    </vertical-nav-menu>
    <!-- /Vertical Nav Menu -->

    <!-- Vertical Nav Menu Overlay -->
    <div
      class="sidenav-overlay"
      :class="overlayClasses"
      @click="isVerticalMenuActive = false"
    />
    <!-- /Vertical Nav Menu Overlay -->

    <!-- Content -->
    <div class="main-content">
      <div class="content-wrapper">
        <div class="content-body">
          <slot />
        </div>
        
        <!-- Footer -->
        <footer class="footer footer-light">
          <slot name="footer">
            <app-footer />
          </slot>
        </footer>
        <!-- /Footer -->
      </div>
    </div>
    <!--/ Content -->
  </div>
</template>

<script>
import Navbar from '@/layouts/components/Navbar.vue'
import AppFooter from '@/layouts/components/AppFooter.vue'
import VerticalNavMenu from './components/vertical-nav-menu/VerticalNavMenu.vue'

export default {
  name: 'LayoutVerticalSimple',
  components: {
    Navbar,
    AppFooter,
    VerticalNavMenu,
  },
  data() {
    return {
      isVerticalMenuActive: true,
      isNavMenuHidden: false,
      isMobile: false,
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  computed: {
    overlayClasses() {
      if (this.isMobile && this.isVerticalMenuActive) return 'show'
      return null
    },
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 1200
      // En desktop, siempre mantener el menú visible
      if (!this.isMobile) {
        this.isVerticalMenuActive = true
      }
    },
    toggleVerticalMenuActive() {
      // Solo permitir toggle en móvil
      if (this.isMobile) {
        this.isVerticalMenuActive = !this.isVerticalMenuActive
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.vertical-layout {
  position: relative;
  min-height: 100vh;
  
  .main-content {
    margin-left: 260px;
    min-height: calc(100vh - 4rem);
    transition: margin-left 0.3s ease;
    background-color: #f8f9fa;
    display: flex;
    flex-direction: column;
  }
  
  .content-wrapper {
    padding: 2rem;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  
  .content-body {
    flex: 1;
  }
  
  .footer {
    margin-top: auto;
    padding: 1rem 2rem;
    background-color: #fff;
    border-top: 1px solid #e9ecef;
  }
  
  .sidenav-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    
    &.show {
      opacity: 1;
      visibility: visible;
    }
    
    // Solo mostrar overlay en móvil
    @media (min-width: 1200px) {
      display: none;
    }
  }
}

// Responsive adjustments
@media (max-width: 1199.98px) {
  .vertical-layout .main-content {
    margin-left: 0;
  }
  
  .vertical-layout .content-wrapper {
    padding: 1rem;
  }
  
  .vertical-layout .footer {
    padding: 1rem;
  }
}

// Ensure proper z-index stacking
.header-navbar {
  z-index: 1001;
}

.vertical-nav-menu {
  z-index: 1000;
}

.sidenav-overlay {
  z-index: 999;
}
</style>
